import { requestHttp } from '@/utils';

const Post = {
  surveyEditPlanShape: '/plan/shape/draw',
  uploadimg: '/plan/uploadimg',
  setPlanInfo: '/plan/scale',
  resolvePlanWall: '/plan/wall/resolve',
  fileConvert: '/plan/file/convert',
  fileConvertAsync: '/plan/file/convert-async',
  imgCache: '/plan/file/img-cache',
  projectImageList: '/project/image/list',
  projectImageSave: '/project/image/save',
  updatePlanSignal: '/plan/signal',
  systemAi: '/system/ai',
  planAreaFirst: `/plan/area/first`,
  batchGetImageUploadKey: '/plan/batch-uploadimg', // 户型图 - 批量上传图片路径信息
  autoWireStart: '/plan/auto-wire/start', // 户型图 - 触发自动布线
  shapeDeviceDefault: '/plan/shape/device/default', // 户型图 - 设备点位设为默认
  shapeWireClear: '/plan/shape/wire/clear', // 户型图 - 清空户型图中所有布线信息
  planBorderWall: '/plan/border-wall/resolve', // 户型图 - 外墙墙体识别
  planBorderWallReset: '/plan/border-wall/reset', // 户型图 - 重置外墙数据
  autoScaleWallStart: '/plan/auto-scale-wall/start', // 异步识别墙体、比例尺
  postSurveyPlanRenderAsyncStart: `/plan/render/async/start`, // 户型图 - 触发热力渲染 https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E6%88%B7%E5%9E%8B%E5%9B%BE%E7%AE%A1%E7%90%86/startRenderUsingPOST
  postSurveyPlanRenderAsyncResult: `/plan/render/async/result`,
  getPlanWallsList: `/plan/wall/list`, // 户型图 - 墙体列表【scheme】 https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E6%88%B7%E5%9E%8B%E5%9B%BE%E7%AE%A1%E7%90%86/getPlanWallListUsingPOST
  delPlanWall: `/plan/wall/delete`, // 户型图 - 墙体删除【scheme】https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E6%88%B7%E5%9E%8B%E5%9B%BE%E7%AE%A1%E7%90%86/replacePlanWallUsingPOST
  replacePlanWall: `/plan/wall/replace`, // 户型图 - 墙体替换【scheme】 https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E6%88%B7%E5%9E%8B%E5%9B%BE%E7%AE%A1%E7%90%86/replacePlanWallUsingPOST_1
  systemPassThroughAi: '/system/pass-through/ai' // 通用AI透传接口
};

const Get = {
  surveyPlanAutoSite: params => {
    return `/plan/auto-site/${params.planId}?sceneId=${params.sceneId}`;
  },
  surveyGetPlanDetail: params => {
    return `/plan/${params.planId}`;
  },
  getProjectConf: params => {
    return `/project/${params.prjId}`;
  },
  getSurveyPlanObstacle: () => {
    return `/plan/obstacle`;
  },
  estListALl: () => {
    return `/est/list/all`;
  },
  getAreaScene: () => {
    return `/plan/area/scene`;
  },
  autoWire: () => {
    return `/plan/auto-wire`; // 户型图 - 获取自动布线结果
  },
  autoScaleWall: () => {
    return `/plan/auto-scale-wall`; // 查询异步识别墙体、比例尺结果
  }
};

const Put = {
  projectEdt: '/project/edt',
  editSurveyApi: '/plan/edt'
};

let FUN = {};

for (let key in Post) {
  FUN[key] = (params = {}) => {
    let { query = {}, data } = params,
      url;
    if (!data) {
      data = params;
    }
    url = Post[key];
    if (typeof url === 'function') {
      url = url(query);
    }
    return requestHttp({
      api: url,
      method: 'POST',
      module: 'survey',
      querys: query,
      params: data,
      timeout: ['setPlanInfo', 'fileConvert', 'resolvePlanWall'].indexOf(key) != -1 ? 120 * 1000 : 30 * 1000
    });
  };
}

for (let key in Put) {
  FUN[key] = (params = {}) => {
    let { query = {}, data } = params,
      url;
    if (!data) {
      data = params;
    }
    url = Put[key];
    if (typeof url === 'function') {
      url = url(query);
    }

    return requestHttp({
      api: url,
      method: 'PUT',
      module: 'survey',
      querys: query,
      params: data,
      timeout: ['editSurveyApi'].indexOf(key) != -1 ? 120 * 1000 : 30 * 1000
    });
  };
}

for (let key in Get) {
  FUN[key] = (params = {}, showMsg = true) => {
    let { query } = params,
      url;
    if (!query) {
      query = params;
    }
    url = Get[key];
    if (typeof url === 'function') {
      url = url(query);
    }
    return requestHttp({
      api: url,
      method: 'GET',
      module: 'survey',
      querys: {
        ...query,
        showMsg
      }
    });
  };
}

// 后端对接AI通用接口
const SystemAiUrl = {
  detectSubArea: '/survey/local/detect_sub_area', //自动识别区域
  autoPlanPretreatment: '/survey/local/auto_plan_pretreatment', // 自动布点预处理
  getHeatmapRecommend: '/survey/local/ai_recommend', // 推荐ap信道及区域带机量预估
  combineAreas: '/survey/local/combine_areas', // 区域合并
  batchRenderHeatMap: '/survey/batch_render',
  detectScaleByLength: '/survey/detect_scale_by_length', // 自动识别比例尺位置,
  // 户型图截取
  floorPlanCrop: '/survey/crop_img'
};

for (let key in SystemAiUrl) {
  FUN[key] = (param, backErrorCode = false) => {
    return FUN.systemAi(
      {
        param: param,
        subUri: SystemAiUrl[key]
      },
      backErrorCode
    );
  };
}

// 后端对接AI通用接口
const SystemAiUrlV2 = {
  autoPlanPretreatmentV2: '/survey/local/auto_plan_pretreatment' // 自动布点预处理
};

for (let key in SystemAiUrlV2) {
  FUN[key] = (param, backErrorCode = false) => {
    return FUN.systemPassThroughAi(
      {
        param: param,
        subUri: SystemAiUrlV2[key]
      },
      backErrorCode
    );
  };
}

export const surveyGetPlanDetail = FUN.surveyGetPlanDetail;
export const surveyEditPlanShape = FUN.surveyEditPlanShape;
export const projectEdt = FUN.projectEdt;
export const getProjectConf = FUN.getProjectConf;
export const editSurveyApi = FUN.editSurveyApi;
export const getSurveyPlanObstacle = FUN.getSurveyPlanObstacle;
export const uploadimg = FUN.uploadimg;
export const setPlanInfo = FUN.setPlanInfo;
export const resolvePlanWall = FUN.resolvePlanWall;
export const fileConvert = FUN.fileConvert;
export const imgCache = FUN.imgCache;
export const fileConvertAsync = FUN.fileConvertAsync;
export const surveyPlanAutoSite = FUN.surveyPlanAutoSite;
export const estListALl = FUN.estListALl;
export const projectImageList = FUN.projectImageList;
export const projectImageSave = FUN.projectImageSave;
export const updatePlanSignal = FUN.updatePlanSignal;
export const batchGetImageUploadKey = FUN.batchGetImageUploadKey;
export const systemAi = FUN.systemAi;
export const detectSubArea = FUN.detectSubArea;
export const combineAreas = FUN.combineAreas;
export const getHeatmapRecommend = FUN.getHeatmapRecommend;
export const autoPlanPretreatment = FUN.autoPlanPretreatment;
export const getAreaScene = FUN.getAreaScene;
export const planAreaFirst = FUN.planAreaFirst;
export const autoWireStart = FUN.autoWireStart;
export const autoWire = FUN.autoWire;
export const batchRenderHeatMap = FUN.batchRenderHeatMap;
export const shapeDeviceDefault = FUN.shapeDeviceDefault;
export const shapeWireClear = FUN.shapeWireClear;
export const planBorderWall = FUN.planBorderWall;
export const planBorderWallReset = FUN.planBorderWallReset;
export const detectScaleByLength = FUN.detectScaleByLength;
export const autoScaleWallStart = FUN.autoScaleWallStart;
export const autoScaleWall = FUN.autoScaleWall;
export const postSurveyPlanRenderAsyncStart = FUN.postSurveyPlanRenderAsyncStart;
export const postSurveyPlanRenderAsyncResult = FUN.postSurveyPlanRenderAsyncResult;
export const getPlanWallsList = FUN.getPlanWallsList;
export const delPlanWall = FUN.delPlanWall;
export const replacePlanWall = FUN.replacePlanWall;
export const systemPassThroughAi = FUN.systemPassThroughAi;
export const autoPlanPretreatmentV2 = FUN.autoPlanPretreatmentV2;

/**
 * 请求户型图截取
 *
 * [接口文档](https://lysora.feishu.cn/docx/JVOadNpjKoDu8Nx3t0Qc2LVonQg) - 金根炎
 *
 * @param {object} params - 请求参数
 * @param {string} params.schemeId - 方案ID
 * @param {string} params.url - 原图地址
 * @param {Array} params.boundingBox - 截取区域
 * @param {Array} params.boundingBox[0] - 截取区域坐标
 * @param {number} params.boundingBox[0][0] - 截取区域左上角坐标
 * @param {number} params.boundingBox[0][1] - 截取区域右上角坐标
 * @param {number} params.boundingBox[0][2] - 截取区域左下角坐标
 * @param {number} params.boundingBox[0][4] - 截取区域右下角坐标
 * @example
 * ```js
 * import { requestSchemeFloorPlanCrop } from '@/api/survey';
 * requestSchemeFloorPlanCrop({
 *  url: 'https://xxx.jpg',
 *  boundingBox: [[0, 0, 200, 200]]
 * }).then(results => {
 *  console.log(results);
 * });
 * ```
 * @return { Promise<string[]> } 返回截取后的图片地址列表
 */
export function requestSchemeFloorPlanCrop(params) {
  return FUN['floorPlanCrop']({
    ...params
  }).then(result => {
    if (result.code !== 0) {
      return Promise.reject(result);
    } else {
      return result.data.cropUrl;
    }
  });
}
